// const handleCopyText = (value, ref) => {
//   const { top, left } = ref?.current?.getBoundingClientRect();

//   console.log(ref?.current?.getBoundingClientRect())

//   console.log(top, left);

//   // Create a new element
//   const copiedTextElement = document.createElement("div");

//   // Set the text content and styles
//   copiedTextElement.textContent = "Copied to clipboard";
//   copiedTextElement.classList.add('copied-textV1');

//   // Get mouse click position
//   const mouseX = left - 50;
//   const mouseY = top - 210;

//   // Set position based on mouse click
//   copiedTextElement.style.left = `${mouseX}px`;
//   copiedTextElement.style.top = `${mouseY}px`;

//   // Append the element to the body
//   document.body.appendChild(copiedTextElement);

//   // Copy to clipboard
//   navigator.clipboard.writeText(value);

// //Remove the element after a delay
//   setTimeout(() => {
//     document.body.removeChild(copiedTextElement);
//   }, 1500); // Adjust the duration as needed
// };
// export default handleCopyText;

const handleCopyText = (value) => {
    navigator.clipboard.writeText(value);
};

export default handleCopyText;
